module.exports = __webpack_public_path__ + "img/hat_12.51e36449.png";